import { ICreatePatrimonioMaquinaEquipUseCase } from "../../../presentation/useCases/create/create_patrimonio_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CreatePatrimonioMaquinaEquipUseCase
 */

export class CreatePatrimonioMaquinaEquipUseCase implements ICreatePatrimonioMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createPatrimonioMaquinaEquip(
    idPatrimonioCentroCusto?: number | null,
    idChecklistMaquinaEquip?: number | null,
    descricao?: string | null,
    status?: number | null,
  ): Promise<number> {
    return await this.repository.createPatrimonioMaquinaEquip(
      idPatrimonioCentroCusto,
      idChecklistMaquinaEquip,
      descricao,
      status,
    );
  }
}
